<div fxLayout="column" class="layout-padd" [ngStyle]="{'max-height.px': innerHeight}" fxFlexFill>

    <!-- Use Therms -->
    <div fxLayout="column" fxLayoutGap="20px" class="layout-padd">

        <!-- Error message -->
        <div *ngIf="errorMessage" class="layout-padd warn rad-bord text-center">
            <span class="mat-subheading-1">{{errorMessage}}</span>
        </div>

        <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" class="layout-padd bordered-card">
            <mat-slide-toggle class="great-ico" [(ngModel)]="salesTerms" class="text-center" angulartics2On="click" angularticsAction="acceptTerms" angularticsCategory="order"></mat-slide-toggle>
            <div class="text-center">
                <span class="mat-subheading-1" ngClass.xs="mat-caption">{{'confirmOrderComponent.read' | translate}} <strong
                    class="primary-ico" (click)="goTerms()">{{'confirmOrderComponent.conditions' | translate}}</strong></span>
            </div>
        </div>

        <!-- if is not paypal -->

        <div fxLayoutAlign="space-between" fxLayoutGap="10px" *ngIf="currSM.payment_type !== 'online_paypal'">
            <button mat-stroked-button color="warn" fxFlex="50" (click)="closeDial()" angulartics2On="click" angularticsAction="cancelOrder" angularticsCategory="order">{{'button.cancel'|translate }}</button>
            <button mat-stroked-button color="accent" fxFlex="50" (click)="submitOrder()" [disabled]="!salesTerms" angulartics2On="click" angularticsAction="confirmOrder" angularticsCategory="order">{{'confirmOrderComponent.confirm' | translate}} </button>
        </div>

        <!-- If paypal -->
        <div fxLayout="column" *ngIf="currSM.payment_type === 'online_paypal'">
            <div #paypal></div>
            <button mat-stroked-button color="warn" (click)="closeDial()" angulartics2On="click" angularticsAction="cancelOrder" angularticsCategory="order" style="height: 40px;">{{'button.cancel'|translate }}</button>
        </div>

    </div>

    <app-popup-loader [flagLoading]="loader" [statusMessage]="loaderMessage" [size]="30"></app-popup-loader>

</div>
